<template>
  <div class="animated fadeIn">
    <b-card>
      <template slot="header"><i class='fa fa-align-justify'></i>Sites Upload Center</template>
        <b-row>
          <b-col sm="12">
            STEP 1. Download the sample file :
            <b-button class="mt-0" variant="link" @click="modal_charge_agree = true">Get Sample File</b-button>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col sm="12">
            STEP 2. Add the site you want to register to the sample and upload it, support CSV file
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col sm="10">
            <b-form-file
              ref="file_input"
              v-model="file"
              @input="selected"
              @change="selected"
              :state="Boolean(file && file.name)"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
              :allowed="true"
              accept="text/csv"
            ></b-form-file>
          </b-col>
          <b-col sm="2">
            <b-btn :disabled="!file || (file && !file.name) || loading" @click="reset" block variant="outline-success">Clear</b-btn>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col sm="10">
            STEP 3. View the site information you want to register and upload it.
          </b-col>
          <b-col sm="2">
            <b-badge variant="success">Complated : {{progress.done}}</b-badge>
            <b-badge variant="danger">Error : {{progress.error}}</b-badge>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col sm="4">
            <span class="text-center" v-b-tooltip.hover title="can custom showing count">
              Show Count
              <select v-model="so.perPage" @change="refresh" :disabled="loading">
                <option disabled value="15">Default 15</option>
                <option value=10>10</option>
                <option value=50>50</option>
                <option value=100>100</option>
                <option value=500>500</option>
              </select>
            </span>
          </b-col>
          <b-col sm="4">
            <!-- 컬럼 관련 메뉴 -->
            <b-form-group label="Select custom showing data">
              <b-form-checkbox-group
                v-model="sel"
                :options="options"
                button-variant="primary"
                name="option"
                buttons
              ></b-form-checkbox-group>
            </b-form-group>
          </b-col>
          <b-col sm="4">
            <b-input-group size="sm">
              <b-input-group-prepend>
                <b-btn :disabled="so.adv" variant="outline-secondary" @click="!loading ? refresh() : ''"><i class="fa fa-refresh"></i></b-btn>
                <b-btn :disabled="so.adv" variant="outline-secondary" @click="so = Object.assign({}, so, { skt : '', sv : '' }); !loading ? refresh() : ''"><i class="fa fa-remove"></i></b-btn>
                <b-dropdown :disabled="so.adv" :text="so.skt || 'search'" size="sm" variant="outline-secondary">
                  <b-dropdown-item size="sm" @click="so.sk='fqdn'; so.skt='FQDN'">FQDN</b-dropdown-item>
                  <b-dropdown-item size="sm" @click="so.sk='name'; so.skt='name'">Name</b-dropdown-item>
                </b-dropdown>
              </b-input-group-prepend>
              <b-form-input :disabled="loading" v-model="so.sv" @keyup.native.enter="refresh"></b-form-input>
              <b-input-group-append>
                <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-search"></i></b-btn>
              </b-input-group-append>
            </b-input-group>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col sm="12">
            <!-- 업로드 관련 메뉴 -->
            <center>
              <b-button :disabled="loading" class="mr-2" size="sm" variant="outline-success" @click="toggle('is_alive')"> Toggle Status </b-button>
              <b-button :disabled="loading" class="mr-2" size="sm" variant="outline-info" @click="toggle('is_start')"> Toggle Auto Start </b-button>
              <b-button :disabled="loading" class="mr-2" size="sm" variant="primary" @click="upload_multi()"> Upload All </b-button>
              <b-button :disabled="loading" class="mr-2" size="sm" variant="info" @click="upload_multi(true)"> Upload this Page </b-button>
              <b-button :disabled="loading" class="mr-2" size="sm" variant="warning" @click="clear_done"> Clear complated </b-button>
              <b-button :disabled="!loading" class="mr-2" size="sm" variant="outline-warning" @click="stop = true"> Stop </b-button>
            </center>
          </b-col>
        </b-row>
        <hr v-if="loading">
        <b-row v-if="loading">
          <b-col sm="12">
            <b-progress class="mt-2" :max="sites.length" show-value>
              <b-progress-bar :value="progress.done" variant="success"></b-progress-bar>
              <b-progress-bar :value="progress.error" variant="danger"></b-progress-bar>
            </b-progress>
          </b-col>
        </b-row>
        <hr>
        <!-- <vcl-facebook v-if="loading"></vcl-facebook> -->
        <b-table hover striped small responsive="sm" ref="_list" show-empty empty-text="not found"
          :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk">
          <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
          <template slot="is_alive" slot-scope="row">
            <c-switch color="info" label size="sm" v-model="row.item.is_alive" />
          </template>
          <template slot="is_start" slot-scope="row">
            <c-switch color="info" label size="sm" v-model="row.item.is_start" />
          </template>
          <template slot="name" slot-scope="row">
            <span>{{row.item.name || '-'}}</span>
          </template>
          <template slot="fqdn" slot-scope="row">{{row.item.fqdn || '-'}}</template>
          <template slot="seeds" slot-scope="row">
            {{row.item.seeds.length > 1 ? `${row.item.seeds[0]} .. more ${row.item.seeds.length - 1}` : row.item.seeds[0] || '-'}}
          </template>
          <template slot="schedule" slot-scope="row">
            {{row.item.schedule.length > 1 ? `${row.item.schedule[0]} .. more ${row.item.schedule.length - 1}` : row.item.schedule[0] || '-'}}
          </template>
          <template slot="subs" slot-scope="row">
            {{row.item.subs.length > 1 ? `${row.item.subs[0]} .. more ${row.item.subs.length - 1}` : row.item.subs[0]}}
          </template>
          <template slot="prevents" slot-scope="row">
            {{row.item.prevents.length > 1 ? `${row.item.prevents[0]} .. more ${row.item.prevents.length - 1}` : row.item.prevents[0] || '-'}}
          </template>
          <template slot="policy" slot-scope="row">
            {{row.item.policy && row.item.policy ? row.item.policy : '-'}}
          </template>
          <template slot="func" slot-scope="row">
            <!-- {{startRow - (startRow - row.index)}} -->
             <p>
              <b-tooltip target="disabled-wrapper">{{row.item.msg}}</b-tooltip>
             </p>
             <span  id="disabled-wrapper" class="d-inline-block">
              <b-btn @click="upload_one(row.index, row.item.fqdn)" :disabled="row.item.is_done" size="sm" :variant="row.item.is_error ? 'danger' : 'outline-primary'">
                <span v-if="row.item.is_error == true" style="cursor:pointer">
                  Error (?)
                </span>
                <span v-else>{{ row.item.is_done ? 'Done' : 'Upload' }}</span>
              </b-btn>
             </span>
          </template>
        </b-table>
        <hr>
        <b-row>
          <b-col class="md-6">
            <b-pagination size="sm" :limit="10" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" prev-text="Prev" next-text="Next" />
          </b-col>
          <b-col class="md-4">
            <div class="pull-right">
              <b-button class="mr-2" size="sm" variant="success" @click="list"> List </b-button>
            </div>
          </b-col>
        </b-row>
      </b-card>
    <router-view @hide-parent="hideList($event)" @refresh="refresh()"></router-view>
    <b-modal v-model="modal_charge_agree" title="Controls all agents" @ok="charge_agree" no-close-on-backdrop header-bg-variant="warning">
      <h5>Charging will begin when the first site registration is made and scanning started</h5>
      <hr>
      <a target="_blank" :href="redir" class="card-link">
        <span class="text-dark">See More</span>
        <i class="fa fa-share"></i>
        {{redir}}
      </a>
      <hr>
      <h6> <b>Are you sure argree?</b></h6>
    </b-modal>
  </div>
</template>

<script>
// import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker';
// import custom from '@/custom';
import codes from '@/codes';
import { Api } from '@/service';
import punycode from 'punycode';
import { Switch as cSwitch } from '@coreui/vue';
import _ from 'lodash';
import reg from '@/reg';
import { VclFacebook } from 'vue-content-loading';
// TODO
// 1. 건바이건으로 해야함
// 2. UX 고려하여 진행사항 표시하는 것으로 변경
// 3. 사이트 생성시 확인 사항이 많아서 이게 최선임

export default {
  components : { DatePicker, cSwitch, VclFacebook },
  name : "UploadCSV",
  props: [],
  watch: {},
  data: () => ({
    modal_charge_agree : false,
    stop : false,
    options : [{ text : 'URL', value : 1 }, { text : 'Sub Domain', value : 2 }, { text : 'Exception Path', value : 3 }],
    sel : [],
    progress : { done : 0, error : 0, },
    loading : false,
    so : Object.assign({}, codes.DEFAULT_OPT, { skt : 'FQDN', sv : '' }),
    file : {},
    file_data : "",
    base_href : location.hostname == 'localhost' ? 'https://api.f1secaas.net' : `${location.protocol}//${location.hostname.replace(/^[^\\.]*\./, 'api.')}`,
    sites : [],
    fields_data : [
      { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%', option : 0 },
      { key: 'is_alive', label: 'Status', sortable: false, thStyle: 'width: 10%', option : 0 },
      { key: 'is_start', label: 'Inspection at registration', sortable: false, thStyle: 'width: 10%', option : 0 },
      { key: 'name', label: 'Name', sortable: false, option : 0 },
      { key: 'fqdn', label: 'FQDN', sortable: false, option : 0 },
      { key: 'schedule', label: 'Schedule', sortable: true, option : 0 },
      { key: 'policy', label: 'Policy Name', sortable: true, option : 0 },
      { key: 'seeds', label: 'URL', sortable: true, option : 1 },
      { key: 'subs', label: 'Sub Domain', sortable: true, option : 2 }, // option 임
      { key: 'prevents', label: 'Exception Path', sortable: true, option : 3 }, // option 임
      { key: 'func', label: 'Action', sortable: false, thStyle: 'width: 10%' , option : 0 },
    ]
  }),
  computed: {
    redir() {
      // console.log(`${location.protocol}//${location.hostname == 'localhost' ? 'www.f1secaas.net' : location.hostname.replace('console.', 'www')}/ToS`)
      return `${location.protocol}//${location.hostname == 'localhost' ? 'www.f1secaas.net' : location.hostname.replace('console.', 'www.')}/ToS`
    },
    startRow : function() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    rowCount: function() { return this.so.totalRows || 0; },
    fields() {
      return _.map(this.fields_data, f => {
        if(_.indexOf(this.sel, f.option) > -1 || f.option < 1) {
          return f
        }
      })
    }
  },
  methods: {
    async charge_agree() {
      try {
        let rs = await Api.Manager_Call('wmds.site', 'agree', { ts : new Date().getTime() });
        if(rs.error) { return this.$toastr.e("apply agreement failed") }
        // 시스템 로그가 남아야 함, 동의 부분 관련
        this.download_sample()
      } catch (e) { console.log(e); this.$toastr.e("apply agreement failed") }

    },
    download_sample: function() { window.open(`${this.base_href}` + '/downloads/wmds/v1/site/upload/format/sample.csv', '_blank') },
    selected(file) {
      try {
        if(!file || (file && !file.name)) { return console.log("no have file") }
        let local = this;
        let reader = new FileReader();
        reader.onload = () => {
          local.file_data = reader.result.split('\n')
          local.csv_parser(local.file_data)
        }
        reader.readAsText(file);
      } catch (e) { console.log(e) }
    },
    csv_parser(data) {
      // console.log(data)
      if(data.length < 3) { return this.$toastr.e("It is sample file") }

      // "Name", "FQDN", "Check_Start_URL", "Schedule(by cron)", "Sub_Domain", "Exception_Path"
      let sites = data.slice(2, data.length)
      sites.forEach(site => {
        let s = site.split(',')
        if(_.compact(s).length < 5) { return console.log('no have a row') }

        this.sites.push({
          is_done : false,
          is_alive : true,
          is_start : false,
          name : s[0],
          fqdn : this.check_kr(s[1])+`${new Date().getTime()}`,
          seeds : _.compact(_.map(s[2].split(';'), x => this.check_kr(x))),
          schedule : _.compact(s[3].split(';')),
          subs : _.compact(_.map(s[4].split(';'), x => this.check_kr(x))), // 한글 서브 도메인 지원
          prevents : _.compact(s[5].split(';')),
          policy : (s[6] || '').trim(),
        })
      });
      this.refresh()
    },
    check_kr(domain) {
      // 한글 도메인 등록
      if(domain && /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(domain)){
        let d = domain.split('://')
        return (d.length > 1 ? d[0]+'://' : '' ) + punycode.toASCII(d.length > 1 ? d[1] : d[0])
      }
      return domain
    },
    reset() { this.so = Object.assign({}, codes.DEFAULT_OPT, { opt : {} }); this.sites = []; this.file = {}; this.progress = { error : 0, done : 0 }; this.$refs.file_input.reset(); this.refresh(); },
    refresh() { this.$refs._list.refresh(); this.change_to_disable = []; this.change_to_enable = []; this.$toastr.i("Refreshed") },
    getItems: function(ctx) { return this.load(ctx); },
    load() {
      let offset = (this.so.currentPage-1 || 0) * Number(this.so.perPage)
      let limit = offset + Number(this.so.perPage)
      let list = [];

      if(this.so.sv) {  list = this.so.skt == 'FQDN' ? _.filter(this.sites, s => s.fqdn.indexOf(this.so.sv) > -1) : _.filter(this.sites, s => s.name.indexOf(this.so.sv) > -1)}
      else { list = this.sites }
      this.so.totalRows = list.length
      console.log('slice', offset, limit, this.sites.length, 'return', list.slice(offset, limit).length)
      return list.slice(offset, limit)
    },
    toggle(type) {
      let offset = (this.so.currentPage-1 || 0) * Number(this.so.perPage)
      let limit = offset + Number(this.so.perPage)
      console.log('toggle', 'offset', offset, 'limit', limit)
      // console.log('slice', offset, limit, this.sites.length)
      this.sites.forEach((s, index) => {
        if(index >=  offset && index < limit) {
          s.is_start = type == 'is_start' ? !s.is_start : s.is_start
          s.is_alive = type == 'is_alive' ? !s.is_alive : s.is_alive
        }
      })
      this.refresh()
    },
    clear_done() {
      this.sites = _.filter(this.sites, s => !s.is_done & !s.is_error)
      this.refresh()
    },
    async upload_multi(only_page = false) {
      if(this.sites.length < 1) { return this.$toastr.w("no have data") }
      this.loading = true
      let offset = (this.so.currentPage-1 || 0) * Number(this.so.perPage)
      let limit = offset + Number(this.so.perPage)

      for (let origin_index = 0; origin_index < this.sites.length; origin_index++) {
        if(this.stop) { break }

        console.log(only_page, "WTF", origin_index,  offset, origin_index, limit)
        if(only_page && !(origin_index >=  offset && origin_index < limit)) { continue }

        if(this.sites[origin_index].is_done) {
          console.log('already complated ' + this.sites[origin_index].fqdn);
          this.$toastr.w("already complated " + this.sites[origin_index].fqdn)
          continue
        }
        let rs = await this.upload_one(origin_index)
        if(rs) { this.progress.done += 1 }
        else { this.progress.error += 1 }
        console.log(this.sites[origin_index].fqdn, rs)
      }
      if(this.stop) { this.stop = false; this.$toastr.w("Stopped") }
      setTimeout(() => this.loading = false, 3 * 1000)
    },
    async upload_one(origin_index) {
      let s = this.sites[origin_index]

      if(!s.name || s.name.length < 1) {  this.sites[origin_index] = Object.assign({}, this.sites[origin_index], { msg : 'no have name name', is_done : true, is_error : true }); }
      if(!s.policy || s.policy.length < 1) {  this.sites[origin_index] = Object.assign({}, this.sites[origin_index], { msg : 'no have policy name', is_done : true, is_error : true }); }
      if(!s.fqdn || s.fqdn.length < 1) {  this.sites[origin_index] = Object.assign({}, this.sites[origin_index], { msg : 'no have fqdn name', is_done : true, is_error : true }); }
      if(!s.schedule || s.schedule.length < 1) {  this.sites[origin_index] = Object.assign({}, this.sites[origin_index], { msg : 'no have schedule name', is_done : true, is_error : true }); }
      if(!s.seeds || s.seeds.length < 1) {  this.sites[origin_index] = Object.assign({}, this.sites[origin_index], { msg : 'no have start URL', is_done : true, is_error : true }); }
      // option
      // if(!site.subs || site.subs.length < 1) { return this.sites[origin_index].msg = "no have sub domain" }
      // if(!site.prevents || site.prevents.length < 1) { return this.sites[origin_index].msg = "no have exception path" }
      if(reg.prevent_domain.test(punycode.toASCII(s.fqdn))) { return this.sites[origin_index].msg = "Domain Type Check"; }

      let site  = {
        policy : s.policy.replace('\r\n', ''),
        seeds : _.map(s.seeds, x => x.replace('/r', '')),
        schedule : _.map(s.schedule, x => x.replace('/r', '')),
        prevents : _.map(s.prevents, x => x.replace('/r', '')),
        subs : _.map(s.subs, x => x.replace('/r', '')),
        fqdn : s.fqdn,
        name : s.name,
        is_alive : s.is_alive,
        is_start : s.is_start,
      }
      try {
        // 업로드 시도
        // insert.upload.list 메소드도 있으나, 작업이 많아서 한번에 하기가 빡셈, 일단 구현 후 나중에 속도를 고려하여 개선하는 것으로 해야함 다른 할일이 너무 많음
        let rs = await Api.Manager_Call('site', 'insert.upload.one', site);
        this.sites[origin_index].is_done = true
        if(!rs.error) { this.$toastr.s(`${site.fqdn} upload successful`) }
        else {
          this.sites[origin_index].is_error = true
          this.sites[origin_index].msg = rs.reason
        }

      } catch(e) { this.sites[origin_index].msg = e.data.message; this.sites[origin_index].is_error = this.sites[origin_index].is_done = true }
      if(this.sites[origin_index].is_error) { this.$toastr.e(`${site.fqdn} upload failed`) }
      // 업로드 성공 여부를 리턴
      return this.sites[origin_index].is_error ? false : true
    },
    list: function() { this.$router.push({ name : 'wmds_site' }) },
  },
  created: function() { console.log('site.list.vue', 'created'); },
  destroyed: function() { console.log('site.list.vue', 'destroyed'); },
  mounted: function() { console.log('site.list.vue', 'mounted'); },
}
</script>
